import React from 'react';
import HCaptcha from '@hcaptcha/react-hcaptcha';

const Captcha = React.forwardRef(
  (properties, reference) => <HCaptcha {...properties} ref={reference} />,
);

export default Captcha;
